export const QueryKeys = {
    GetAllNomenclature: 'get-all-nomenclature',
    GetAllNomenclatureQueryOptions: 'get-all-nomenclature-options',
    GetAllNomenclaturesAvailableCountQueryOptions: 'get-all-nomenclature-available-count',
}
